import React, { Component } from "react";
import {
  Button,
  Container,
  Row,Form,
  Col,
  Offcanvas,
} from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import configData from '../config.json';

export default class Abhadetails extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      show: false,
      data: [],
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      errors: {},
      filteredData: null,
      tableClms: [
        {
          name: "S.NO",
          selector: (row, i) => row.abhadetails_Id,
          sortable: true,
          cell: (row) => <span>{row.abhadetails_Id}</span>,
        },
        {name:"Aadhaar Number",selector:(row, i) => row.aadhaarnumber,sortable:true,cell: (row) => <span>{row.aadhaarnumber}</span>,},{name:"Aadhaar Request Id",selector:(row, i) => row.aadhaarrequestId,sortable:true,cell: (row) => <span>{row.aadhaarrequestId}</span>,},{name:"Aadhaar Responce",selector:(row, i) => row.aadhaarresponce,sortable:true,cell: (row) => <span>{row.aadhaarresponce}</span>,},{name:"Login Id",selector:(row, i) => row.loginId,sortable:true,cell: (row) => <span>{row.loginId}</span>,},{name:"Tax Id",selector:(row, i) => row.taxid,sortable:true,cell: (row) => <span>{row.taxid}</span>,},{name:"Mobile",selector:(row, i) => row.mobile,sortable:true,cell: (row) => <span>{row.mobile}</span>,},{name:"OTP",selector:(row, i) => row.otp,sortable:true,cell: (row) => <span>{row.otp}</span>,},{name:"Request OTP",selector:(row, i) => row.requestOtp,sortable:true,cell: (row) => <span>{row.requestOtp}</span>,},{name:"responseOTP",selector:(row, i) => row.responseOTP,sortable:true,cell: (row) => <span>{row.responseOTP}</span>,},{name:"ABHA Number",selector:(row, i) => row.abhanumber,sortable:true,cell: (row) => <span>{row.abhanumber}</span>,},{name:"ABHA Profile",selector:(row, i) => row.abhaprofile,sortable:true,cell: (row) => <span>{row.abhaprofile}</span>,},{name:"Is New",selector:(row, i) => row.isnew,sortable:true,cell: (row) => <span>{row.isnew}</span>,},{name:"PDF Path",selector:(row, i) => row.pdfpath,sortable:true,cell: (row) => <span>{row.pdfpath}</span>,},{name:"PDF Request",selector:(row, i) => row.pdfrequest,sortable:true,cell: (row) => <span>{row.pdfrequest}</span>,},{name:"PDF Request",selector:(row, i) => row.pdfrequest,sortable:true,cell: (row) => <span>{row.pdfrequest}</span>,},{name:"Dummy One",selector:(row, i) => row.dummyOne,sortable:true,cell: (row) => <span>{row.dummyOne}</span>,},{name:"Dummy Three",selector:(row, i) => row.dummyTwo,sortable:true,cell: (row) => <span>{row.dummyTwo}</span>,},{name:"Dummy Four",selector:(row, i) => row.dummyFour,sortable:true,cell: (row) => <span>{row.dummyFour}</span>,},{name:"Dummy Five",selector:(row, i) => row.dummyFive,sortable:true,cell: (row) => <span>{row.dummyFive}</span>,},
        //***tableClms
        {
          name: "Actions",
          sortable: false,
          cell: (row) => (
            <div>
              {/* edit button and delete button */}
              <Button
              style={{marginRight:"10px"}}
                variant="primary"
                onClick={() => this.AbhadetailseditHandler(row)}
                className="bi bi-pen" 
              >
              </Button>
              <Button
                variant="danger"
                onClick={() => this.handleDelete(row)}
                className="bi bi-trash danger"
              >
              </Button>
            </div>
          ),
        },
      ],
      currentPage: 1,
      itemsPerPage: 10,
      isEditing: false,
     abhadetails_Id:"",
      aadhaarnumber:'',aadhaarrequestId:'',aadhaarresponce:'',loginId:'',taxid:'',mobile:'',otp:'',requestOtp:'',responseOTP:'',abhanumber:'',abhaprofile:'',isnew:'',pdfpath:'',pdfrequest:'',pdfrequest:'',dummyOne:'',dummyTwo:'',dummyFour:'',dummyFive:'',
      //***state
    };
  }
  // offcanvas Open
  handleOffcanvasShow = () => {
    this.setState({ show: true, aadhaarnumber:'',aadhaarrequestId:'',aadhaarresponce:'',loginId:'',taxid:'',mobile:'',otp:'',requestOtp:'',responseOTP:'',abhanumber:'',abhaprofile:'',isnew:'',pdfpath:'',pdfrequest:'',pdfrequest:'',dummyOne:'',dummyTwo:'',dummyFour:'',dummyFive:'', });
  };
  // Offcanvas close button
  handleOffcanvasClose = () => {
    this.setState({ show: false,isEditing: false, aadhaarnumber:'',aadhaarrequestId:'',aadhaarresponce:'',loginId:'',taxid:'',mobile:'',otp:'',requestOtp:'',responseOTP:'',abhanumber:'',abhaprofile:'',isnew:'',pdfpath:'',pdfrequest:'',pdfrequest:'',dummyOne:'',dummyTwo:'',dummyFour:'',dummyFive:'', });
  };
  showToast = (msg, type) => {
    switch(type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warn(msg); // 'warn' is used instead of 'warning'
        break;
      default:
        toast.info(msg);
     }   
  };
  AbhadetailseditHandler = (row)=>{
      // e.preventDefault();
      this.setState({ isEditing: true,abhadetails_Id:row.abhadetails_Id, aadhaarnumber:row.aadhaarnumber,aadhaarrequestId:row.aadhaarrequestId,aadhaarresponce:row.aadhaarresponce,loginId:row.loginId,taxid:row.taxid,mobile:row.mobile,otp:row.otp,requestOtp:row.requestOtp,responseOTP:row.responseOTP,abhanumber:row.abhanumber,abhaprofile:row.abhaprofile,isnew:row.isnew,pdfpath:row.pdfpath,pdfrequest:row.pdfrequest,pdfrequest:row.pdfrequest,dummyOne:row.dummyOne,dummyTwo:row.dummyTwo,dummyFour:row.dummyFour,dummyFive:row.dummyFive, //***editstate
      });
  }
       
AbhadetailsfetchHandler = () => {
  var formData = new FormData();
  formData.append("sId", this.state.sId);
 formData.append("uId", this.state.uId);
            fetch(configData.api_url +'C_Abhadetails/list', {  // Enter your IP address here
        
              method: 'POST', 
              //headers :{ 'Content-Type' : 'application/json'},
              mode: 'cors', 
              body: formData// body data type must match "Content-Type" header
            }).then(response => response.json())
            .then((data) => {
              if (data.status === "success") {
                this.setState({ data: data.list });
              }
            });
           }
           AbhadetailssubmitHandler=(e)=>{
            e.preventDefault();
              //   setButtons(contacts);
             var formData = new FormData();
             formData.append("sId", this.state.sId);
              formData.append("uId", this.state.uId);
             formData.append('aadhaarnumber',this.state.aadhaarnumber);
formData.append('aadhaarrequestId',this.state.aadhaarrequestId);
formData.append('aadhaarresponce',this.state.aadhaarresponce);
formData.append('loginId',this.state.loginId);
formData.append('taxid',this.state.taxid);
formData.append('mobile',this.state.mobile);
formData.append('otp',this.state.otp);
formData.append('requestOtp',this.state.requestOtp);
formData.append('responseOTP',this.state.responseOTP);
formData.append('abhanumber',this.state.abhanumber);
formData.append('abhaprofile',this.state.abhaprofile);
formData.append('isnew',this.state.isnew);
formData.append('pdfpath',this.state.pdfpath);
formData.append('pdfrequest',this.state.pdfrequest);
formData.append('pdfrequest',this.state.pdfrequest);
formData.append('dummyOne',this.state.dummyOne);
formData.append('dummyTwo',this.state.dummyTwo);
formData.append('dummyFour',this.state.dummyFour);
formData.append('dummyFive',this.state.dummyFive);

             //***tableData*
             fetch(configData.api_url + 'C_Abhadetails/add', {  // Enter your IP address here
          
               method: 'POST',
               //headers :{ 'Content-Type' : 'application/json'},
               mode: 'cors',
               body: formData// body data type must match "Content-Type" header
             }).then(response => response.json())
               .then((data) => {
                 this.showToast(data.message, data.status);
                 if (data.status === "success") {
                   this.AbhadetailsfetchHandler();
                   this.handleOffcanvasClose();
                   this.setState({aadhaarnumber:'',aadhaarrequestId:'',aadhaarresponce:'',loginId:'',taxid:'',mobile:'',otp:'',requestOtp:'',responseOTP:'',abhanumber:'',abhaprofile:'',isnew:'',pdfpath:'',pdfrequest:'',pdfrequest:'',dummyOne:'',dummyTwo:'',dummyFour:'',dummyFive:'',});
                }
              });
             }
   AbhadetailsupdateHandler=(e)=>{
        e.preventDefault();
     var formData = new FormData();
     formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("abhadetails_Id", this.state.abhadetails_Id);
          formData.append('aadhaarnumber',this.state.aadhaarnumber);
formData.append('aadhaarrequestId',this.state.aadhaarrequestId);
formData.append('aadhaarresponce',this.state.aadhaarresponce);
formData.append('loginId',this.state.loginId);
formData.append('taxid',this.state.taxid);
formData.append('mobile',this.state.mobile);
formData.append('otp',this.state.otp);
formData.append('requestOtp',this.state.requestOtp);
formData.append('responseOTP',this.state.responseOTP);
formData.append('abhanumber',this.state.abhanumber);
formData.append('abhaprofile',this.state.abhaprofile);
formData.append('isnew',this.state.isnew);
formData.append('pdfpath',this.state.pdfpath);
formData.append('pdfrequest',this.state.pdfrequest);
formData.append('pdfrequest',this.state.pdfrequest);
formData.append('dummyOne',this.state.dummyOne);
formData.append('dummyTwo',this.state.dummyTwo);
formData.append('dummyFour',this.state.dummyFour);
formData.append('dummyFive',this.state.dummyFive);

      //***tableData1
          fetch(configData.api_url +'C_Abhadetails/update', {  
            method: 'POST', 
            mode: 'cors', 
            body: formData
          }).then(response => response.json())
            .then((data) => {
              this.showToast(data.message, data.status);
            if (data.status === "success") {
              this.AbhadetailsfetchHandler();
              this.handleOffcanvasClose();
            }
          });
         }

  componentDidMount() {
    this.AbhadetailsfetchHandler();
    
     //***componentDidMount
  }
  handleaadhaarnumberChange = (e) => {
  e.preventDefault();
  const fieldValue = e.target.value;
  this.setState({aadhaarnumber: fieldValue });
};handleaadhaarrequestIdChange = (e) => {
  e.preventDefault();
  const fieldValue = e.target.value;
  this.setState({aadhaarrequestId: fieldValue });
};handleaadhaarresponceChange = (e) => {
  e.preventDefault();
  const fieldValue = e.target.value;
  this.setState({aadhaarresponce: fieldValue });
};handleloginIdChange = (e) => {
  e.preventDefault();
  const fieldValue = e.target.value;
  this.setState({loginId: fieldValue });
};handletaxidChange = (e) => {
  e.preventDefault();
  const fieldValue = e.target.value;
  this.setState({taxid: fieldValue });
};handlemobileChange = (e) => {
  e.preventDefault();
  const fieldValue = e.target.value;
  this.setState({mobile: fieldValue });
};handleotpChange = (e) => {
  e.preventDefault();
  const fieldValue = e.target.value;
  this.setState({otp: fieldValue });
};handlerequestOtpChange = (e) => {
  e.preventDefault();
  const fieldValue = e.target.value;
  this.setState({requestOtp: fieldValue });
};handleresponseOTPChange = (e) => {
  e.preventDefault();
  const fieldValue = e.target.value;
  this.setState({responseOTP: fieldValue });
};handleabhanumberChange = (e) => {
  e.preventDefault();
  const fieldValue = e.target.value;
  this.setState({abhanumber: fieldValue });
};handleabhaprofileChange = (e) => {
  e.preventDefault();
  const fieldValue = e.target.value;
  this.setState({abhaprofile: fieldValue });
};handleisnewChange = (e) => {
  e.preventDefault();
  const fieldValue = e.target.value;
  this.setState({isnew: fieldValue });
};handlepdfpathChange = (e) => {
  e.preventDefault();
  const fieldValue = e.target.value;
  this.setState({pdfpath: fieldValue });
};handlepdfrequestChange = (e) => {
  e.preventDefault();
  const fieldValue = e.target.value;
  this.setState({pdfrequest: fieldValue });
};handlepdfrequestChange = (e) => {
  e.preventDefault();
  const fieldValue = e.target.value;
  this.setState({pdfrequest: fieldValue });
};handledummyOneChange = (e) => {
  e.preventDefault();
  const fieldValue = e.target.value;
  this.setState({dummyOne: fieldValue });
};handledummyTwoChange = (e) => {
  e.preventDefault();
  const fieldValue = e.target.value;
  this.setState({dummyTwo: fieldValue });
};handledummyFourChange = (e) => {
  e.preventDefault();
  const fieldValue = e.target.value;
  this.setState({dummyFour: fieldValue });
};handledummyFiveChange = (e) => {
  e.preventDefault();
  const fieldValue = e.target.value;
  this.setState({dummyFive: fieldValue });
};
  //***inputFunctions
  handleRowSelect = (row) => {
    this.setState({
      selectedRow: row.index,
    });
  };
  handleRowUpdate = (newData, oldData) => {
    const data = [...this.state.data];
    const index = oldData.index;
    data[index] = newData;
    this.setState({ data });
  };

  handleEdit = (row) => {
    console.log(`Editing row with ID ${row.id}`);
    // implement your edit logic here
  };
handleDelete = (row, index) => {
  var formData = new FormData();
    formData.append('abhadetails_Id', row.abhadetails_Id);
    fetch(configData.api_url +'C_Abhadetails/delete', {
          method: 'POST', 
        mode: 'cors', 
        body: formData
      }).then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.AbhadetailsfetchHandler();
        }
      });
  };
  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ itemsPerPage: newPerPage, currentPage: page });
  };

  handleFilter = (e) => {
    const searchValue = e.target.value.toLowerCase();
    const filteredData = this.state.data.filter((row) => {
      return Object.values(row).join(" ").toLowerCase().includes(searchValue);
    });
    this.setState({ filteredData });
  };

  render() {
    const paginatedData = this.state.filteredData
      ? this.state.filteredData.slice(
          (this.state.currentPage - 1) * this.state.itemsPerPage,
          this.state.currentPage * this.state.itemsPerPage
        )
      : this.state.data.slice(
          (this.state.currentPage - 1) * this.state.itemsPerPage,
          this.state.currentPage * this.state.itemsPerPage
        );

    return (
      <div className="page-title">
      <div className="row">
        <div className="col-md-12 col-sm-12 col-xs-12">
          <div className="x_panel">
            <div className="x_content">
              <div
                id="datatable_wrapper"
                className="dataTables_wrapper form-inline
                dt-bootstrap no-footer"
              >
                <Row className="row">
                <div>
                 <h3 className="logoskybluecolor" style={{ textAlign: "start" }}>ABHA Details</h3>
                </div>
            <Col
            className="d-flex justify-content-end"
            style={{ marginRight: "5px", marginTop: "20px" }}
          >
           <Button
                variant="primary" style={{ float: "right", marginBottom: "10px" }}
                className="bi bi-plus "
                onClick={this.handleOffcanvasShow}
              >
              New
              </Button>
            <Offcanvas
              show={this.state.show}
              onHide={this.handleOffcanvasClose}
              {...this.props}
              style={{ width: "500px" }}
              placement="end"
              backdrop="true"
            >
              <Offcanvas.Header closeButton>
                <Offcanvas.Title>Add Abhadetails</Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                <Container style={{ "overflowY": "auto", height: "auto" }}>
                <Row className="divstyle">
                    <Row>
                      <Form>
                  <Row>
  <Col  lg="4" md="4">
  <Form.Label style={{ paddingTop: "8px" }}>Aadhaar Number</Form.Label>
  </Col>
  <Col lg="8" md="8">
  <Form.Control type="text" onChange={this.handleaadhaarnumberChange} className="form-control" name="aadhaarnumber" value={this.state.aadhaarnumber} required="required" placeholder="Enter Aadhaar Number" />
  </Col>  
  <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.aadhaarnumber} </div>
</Row><br/><Row>
  <Col  lg="4" md="4">
  <Form.Label style={{ paddingTop: "8px" }}>Aadhaar Request Id</Form.Label>
  </Col>
  <Col lg="8" md="8">
  <Form.Control type="text" onChange={this.handleaadhaarrequestIdChange} className="form-control" name="aadhaarrequestId" value={this.state.aadhaarrequestId} required="required" placeholder="Enter Aadhaar Request Id" />
  </Col>  
  <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.aadhaarrequestId} </div>
</Row><br/><Row>
  <Col  lg="4" md="4">
  <Form.Label style={{ paddingTop: "8px" }}>Aadhaar Responce</Form.Label>
  </Col>
  <Col lg="8" md="8">
  <Form.Control type="text" onChange={this.handleaadhaarresponceChange} className="form-control" name="aadhaarresponce" value={this.state.aadhaarresponce} required="required" placeholder="Enter Aadhaar Responce" />
  </Col>  
  <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.aadhaarresponce} </div>
</Row><br/><Row>
  <Col  lg="4" md="4">
  <Form.Label style={{ paddingTop: "8px" }}>Login Id</Form.Label>
  </Col>
  <Col lg="8" md="8">
  <Form.Control type="text" onChange={this.handleloginIdChange} className="form-control" name="loginId" value={this.state.loginId} required="required" placeholder="Enter Login Id" />
  </Col>  
  <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.loginId} </div>
</Row><br/><Row>
  <Col  lg="4" md="4">
  <Form.Label style={{ paddingTop: "8px" }}>Tax Id</Form.Label>
  </Col>
  <Col lg="8" md="8">
  <Form.Control type="text" onChange={this.handletaxidChange} className="form-control" name="taxid" value={this.state.taxid} required="required" placeholder="Enter Tax Id" />
  </Col>  
  <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.taxid} </div>
</Row><br/><Row>
  <Col  lg="4" md="4">
  <Form.Label style={{ paddingTop: "8px" }}>Mobile</Form.Label>
  </Col>
  <Col lg="8" md="8">
  <Form.Control type="text" onChange={this.handlemobileChange} className="form-control" name="mobile" value={this.state.mobile} required="required" placeholder="Enter Mobile" />
  </Col>  
  <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.mobile} </div>
</Row><br/><Row>
  <Col  lg="4" md="4">
  <Form.Label style={{ paddingTop: "8px" }}>OTP</Form.Label>
  </Col>
  <Col lg="8" md="8">
  <Form.Control type="text" onChange={this.handleotpChange} className="form-control" name="otp" value={this.state.otp} required="required" placeholder="Enter OTP" />
  </Col>  
  <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.otp} </div>
</Row><br/><Row>
  <Col  lg="4" md="4">
  <Form.Label style={{ paddingTop: "8px" }}>Request OTP</Form.Label>
  </Col>
  <Col lg="8" md="8">
  <Form.Control type="text" onChange={this.handlerequestOtpChange} className="form-control" name="requestOtp" value={this.state.requestOtp} required="required" placeholder="Enter Request OTP" />
  </Col>  
  <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.requestOtp} </div>
</Row><br/><Row>
  <Col  lg="4" md="4">
  <Form.Label style={{ paddingTop: "8px" }}>responseOTP</Form.Label>
  </Col>
  <Col lg="8" md="8">
  <Form.Control type="text" onChange={this.handleresponseOTPChange} className="form-control" name="responseOTP" value={this.state.responseOTP} required="required" placeholder="Enter responseOTP" />
  </Col>  
  <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.responseOTP} </div>
</Row><br/><Row>
  <Col  lg="4" md="4">
  <Form.Label style={{ paddingTop: "8px" }}>ABHA Number</Form.Label>
  </Col>
  <Col lg="8" md="8">
  <Form.Control type="text" onChange={this.handleabhanumberChange} className="form-control" name="abhanumber" value={this.state.abhanumber} required="required" placeholder="Enter ABHA Number" />
  </Col>  
  <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.abhanumber} </div>
</Row><br/><Row>
  <Col  lg="4" md="4">
  <Form.Label style={{ paddingTop: "8px" }}>ABHA Profile</Form.Label>
  </Col>
  <Col lg="8" md="8">
  <Form.Control type="text" onChange={this.handleabhaprofileChange} className="form-control" name="abhaprofile" value={this.state.abhaprofile} required="required" placeholder="Enter ABHA Profile" />
  </Col>  
  <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.abhaprofile} </div>
</Row><br/><Row>
  <Col  lg="4" md="4">
  <Form.Label style={{ paddingTop: "8px" }}>Is New</Form.Label>
  </Col>
  <Col lg="8" md="8">
  <Form.Control type="text" onChange={this.handleisnewChange} className="form-control" name="isnew" value={this.state.isnew} required="required" placeholder="Enter Is New" />
  </Col>  
  <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.isnew} </div>
</Row><br/><Row>
  <Col  lg="4" md="4">
  <Form.Label style={{ paddingTop: "8px" }}>PDF Path</Form.Label>
  </Col>
  <Col lg="8" md="8">
  <Form.Control type="text" onChange={this.handlepdfpathChange} className="form-control" name="pdfpath" value={this.state.pdfpath} required="required" placeholder="Enter PDF Path" />
  </Col>  
  <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.pdfpath} </div>
</Row><br/><Row>
  <Col  lg="4" md="4">
  <Form.Label style={{ paddingTop: "8px" }}>PDF Request</Form.Label>
  </Col>
  <Col lg="8" md="8">
  <Form.Control type="text" onChange={this.handlepdfrequestChange} className="form-control" name="pdfrequest" value={this.state.pdfrequest} required="required" placeholder="Enter PDF Request" />
  </Col>  
  <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.pdfrequest} </div>
</Row><br/><Row>
  <Col  lg="4" md="4">
  <Form.Label style={{ paddingTop: "8px" }}>PDF Request</Form.Label>
  </Col>
  <Col lg="8" md="8">
  <Form.Control type="text" onChange={this.handlepdfrequestChange} className="form-control" name="pdfrequest" value={this.state.pdfrequest} required="required" placeholder="Enter PDF Request" />
  </Col>  
  <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.pdfrequest} </div>
</Row><br/><Row>
  <Col  lg="4" md="4">
  <Form.Label style={{ paddingTop: "8px" }}>Dummy One</Form.Label>
  </Col>
  <Col lg="8" md="8">
  <Form.Control type="text" onChange={this.handledummyOneChange} className="form-control" name="dummyOne" value={this.state.dummyOne} required="required" placeholder="Enter Dummy One" />
  </Col>  
  <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dummyOne} </div>
</Row><br/><Row>
  <Col  lg="4" md="4">
  <Form.Label style={{ paddingTop: "8px" }}>Dummy Three</Form.Label>
  </Col>
  <Col lg="8" md="8">
  <Form.Control type="text" onChange={this.handledummyTwoChange} className="form-control" name="dummyTwo" value={this.state.dummyTwo} required="required" placeholder="Enter Dummy Three" />
  </Col>  
  <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dummyTwo} </div>
</Row><br/><Row>
  <Col  lg="4" md="4">
  <Form.Label style={{ paddingTop: "8px" }}>Dummy Four</Form.Label>
  </Col>
  <Col lg="8" md="8">
  <Form.Control type="text" onChange={this.handledummyFourChange} className="form-control" name="dummyFour" value={this.state.dummyFour} required="required" placeholder="Enter Dummy Four" />
  </Col>  
  <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dummyFour} </div>
</Row><br/><Row>
  <Col  lg="4" md="4">
  <Form.Label style={{ paddingTop: "8px" }}>Dummy Five</Form.Label>
  </Col>
  <Col lg="8" md="8">
  <Form.Control type="text" onChange={this.handledummyFiveChange} className="form-control" name="dummyFive" value={this.state.dummyFive} required="required" placeholder="Enter Dummy Five" />
  </Col>  
  <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dummyFive} </div>
</Row><br/>
                  {/* tableContent */}
                  </Form>
                  </Row>
                  </Row>
                  <Row>
                    <Col
                      className="d-flex justify-content-end"
                      style={{ marginRight: "50px" }}
                    >
                      <Button
                        className="button"
                        variant="success"
                        onClick={this.AbhadetailssubmitHandler}
                        style={{
                          marginTop: "20px",
                        }}
                      >
                        Save
                      </Button>
                    </Col>
                  </Row>
                </Container>
              </Offcanvas.Body>
            </Offcanvas>
            {this.state.isEditing && (
              // Edit Offcanvas
              <Offcanvas
              show={this.state.isEditing}
              // onHide={() => this.setState({ isEditing: false })}
              onHide={this.handleOffcanvasClose}
              {...this.props}
              style={{ width: "500px" }}
              placement="end"
              backdrop="true"
            >
              <Offcanvas.Header closeButton>
                <Offcanvas.Title>Edit Abhadetails</Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                <Container style={{ "overflowY": "auto", height: "auto" }}>
                <Row className="divstyle">
                    <Row>
                      <Form>
                  <Row>
  <Col  lg="4" md="4">
  <Form.Label style={{ paddingTop: "8px" }}>Aadhaar Number</Form.Label>
  </Col>
  <Col lg="8" md="8">
  <Form.Control type="text" onChange={this.handleaadhaarnumberChange} className="form-control" name="aadhaarnumber" value={this.state.aadhaarnumber} required="required" placeholder="Enter Aadhaar Number" />
  </Col>  
  <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.aadhaarnumber} </div>
</Row><br/><Row>
  <Col  lg="4" md="4">
  <Form.Label style={{ paddingTop: "8px" }}>Aadhaar Request Id</Form.Label>
  </Col>
  <Col lg="8" md="8">
  <Form.Control type="text" onChange={this.handleaadhaarrequestIdChange} className="form-control" name="aadhaarrequestId" value={this.state.aadhaarrequestId} required="required" placeholder="Enter Aadhaar Request Id" />
  </Col>  
  <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.aadhaarrequestId} </div>
</Row><br/><Row>
  <Col  lg="4" md="4">
  <Form.Label style={{ paddingTop: "8px" }}>Aadhaar Responce</Form.Label>
  </Col>
  <Col lg="8" md="8">
  <Form.Control type="text" onChange={this.handleaadhaarresponceChange} className="form-control" name="aadhaarresponce" value={this.state.aadhaarresponce} required="required" placeholder="Enter Aadhaar Responce" />
  </Col>  
  <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.aadhaarresponce} </div>
</Row><br/><Row>
  <Col  lg="4" md="4">
  <Form.Label style={{ paddingTop: "8px" }}>Login Id</Form.Label>
  </Col>
  <Col lg="8" md="8">
  <Form.Control type="text" onChange={this.handleloginIdChange} className="form-control" name="loginId" value={this.state.loginId} required="required" placeholder="Enter Login Id" />
  </Col>  
  <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.loginId} </div>
</Row><br/><Row>
  <Col  lg="4" md="4">
  <Form.Label style={{ paddingTop: "8px" }}>Tax Id</Form.Label>
  </Col>
  <Col lg="8" md="8">
  <Form.Control type="text" onChange={this.handletaxidChange} className="form-control" name="taxid" value={this.state.taxid} required="required" placeholder="Enter Tax Id" />
  </Col>  
  <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.taxid} </div>
</Row><br/><Row>
  <Col  lg="4" md="4">
  <Form.Label style={{ paddingTop: "8px" }}>Mobile</Form.Label>
  </Col>
  <Col lg="8" md="8">
  <Form.Control type="text" onChange={this.handlemobileChange} className="form-control" name="mobile" value={this.state.mobile} required="required" placeholder="Enter Mobile" />
  </Col>  
  <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.mobile} </div>
</Row><br/><Row>
  <Col  lg="4" md="4">
  <Form.Label style={{ paddingTop: "8px" }}>OTP</Form.Label>
  </Col>
  <Col lg="8" md="8">
  <Form.Control type="text" onChange={this.handleotpChange} className="form-control" name="otp" value={this.state.otp} required="required" placeholder="Enter OTP" />
  </Col>  
  <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.otp} </div>
</Row><br/><Row>
  <Col  lg="4" md="4">
  <Form.Label style={{ paddingTop: "8px" }}>Request OTP</Form.Label>
  </Col>
  <Col lg="8" md="8">
  <Form.Control type="text" onChange={this.handlerequestOtpChange} className="form-control" name="requestOtp" value={this.state.requestOtp} required="required" placeholder="Enter Request OTP" />
  </Col>  
  <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.requestOtp} </div>
</Row><br/><Row>
  <Col  lg="4" md="4">
  <Form.Label style={{ paddingTop: "8px" }}>responseOTP</Form.Label>
  </Col>
  <Col lg="8" md="8">
  <Form.Control type="text" onChange={this.handleresponseOTPChange} className="form-control" name="responseOTP" value={this.state.responseOTP} required="required" placeholder="Enter responseOTP" />
  </Col>  
  <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.responseOTP} </div>
</Row><br/><Row>
  <Col  lg="4" md="4">
  <Form.Label style={{ paddingTop: "8px" }}>ABHA Number</Form.Label>
  </Col>
  <Col lg="8" md="8">
  <Form.Control type="text" onChange={this.handleabhanumberChange} className="form-control" name="abhanumber" value={this.state.abhanumber} required="required" placeholder="Enter ABHA Number" />
  </Col>  
  <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.abhanumber} </div>
</Row><br/><Row>
  <Col  lg="4" md="4">
  <Form.Label style={{ paddingTop: "8px" }}>ABHA Profile</Form.Label>
  </Col>
  <Col lg="8" md="8">
  <Form.Control type="text" onChange={this.handleabhaprofileChange} className="form-control" name="abhaprofile" value={this.state.abhaprofile} required="required" placeholder="Enter ABHA Profile" />
  </Col>  
  <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.abhaprofile} </div>
</Row><br/><Row>
  <Col  lg="4" md="4">
  <Form.Label style={{ paddingTop: "8px" }}>Is New</Form.Label>
  </Col>
  <Col lg="8" md="8">
  <Form.Control type="text" onChange={this.handleisnewChange} className="form-control" name="isnew" value={this.state.isnew} required="required" placeholder="Enter Is New" />
  </Col>  
  <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.isnew} </div>
</Row><br/><Row>
  <Col  lg="4" md="4">
  <Form.Label style={{ paddingTop: "8px" }}>PDF Path</Form.Label>
  </Col>
  <Col lg="8" md="8">
  <Form.Control type="text" onChange={this.handlepdfpathChange} className="form-control" name="pdfpath" value={this.state.pdfpath} required="required" placeholder="Enter PDF Path" />
  </Col>  
  <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.pdfpath} </div>
</Row><br/><Row>
  <Col  lg="4" md="4">
  <Form.Label style={{ paddingTop: "8px" }}>PDF Request</Form.Label>
  </Col>
  <Col lg="8" md="8">
  <Form.Control type="text" onChange={this.handlepdfrequestChange} className="form-control" name="pdfrequest" value={this.state.pdfrequest} required="required" placeholder="Enter PDF Request" />
  </Col>  
  <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.pdfrequest} </div>
</Row><br/><Row>
  <Col  lg="4" md="4">
  <Form.Label style={{ paddingTop: "8px" }}>PDF Request</Form.Label>
  </Col>
  <Col lg="8" md="8">
  <Form.Control type="text" onChange={this.handlepdfrequestChange} className="form-control" name="pdfrequest" value={this.state.pdfrequest} required="required" placeholder="Enter PDF Request" />
  </Col>  
  <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.pdfrequest} </div>
</Row><br/><Row>
  <Col  lg="4" md="4">
  <Form.Label style={{ paddingTop: "8px" }}>Dummy One</Form.Label>
  </Col>
  <Col lg="8" md="8">
  <Form.Control type="text" onChange={this.handledummyOneChange} className="form-control" name="dummyOne" value={this.state.dummyOne} required="required" placeholder="Enter Dummy One" />
  </Col>  
  <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dummyOne} </div>
</Row><br/><Row>
  <Col  lg="4" md="4">
  <Form.Label style={{ paddingTop: "8px" }}>Dummy Three</Form.Label>
  </Col>
  <Col lg="8" md="8">
  <Form.Control type="text" onChange={this.handledummyTwoChange} className="form-control" name="dummyTwo" value={this.state.dummyTwo} required="required" placeholder="Enter Dummy Three" />
  </Col>  
  <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dummyTwo} </div>
</Row><br/><Row>
  <Col  lg="4" md="4">
  <Form.Label style={{ paddingTop: "8px" }}>Dummy Four</Form.Label>
  </Col>
  <Col lg="8" md="8">
  <Form.Control type="text" onChange={this.handledummyFourChange} className="form-control" name="dummyFour" value={this.state.dummyFour} required="required" placeholder="Enter Dummy Four" />
  </Col>  
  <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dummyFour} </div>
</Row><br/><Row>
  <Col  lg="4" md="4">
  <Form.Label style={{ paddingTop: "8px" }}>Dummy Five</Form.Label>
  </Col>
  <Col lg="8" md="8">
  <Form.Control type="text" onChange={this.handledummyFiveChange} className="form-control" name="dummyFive" value={this.state.dummyFive} required="required" placeholder="Enter Dummy Five" />
  </Col>  
  <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dummyFive} </div>
</Row><br/>
                  {/* tableContent */}
                  </Form>
                  </Row>
                  </Row>
                  <Row>
                    <Col
                      className="d-flex justify-content-end"
                      style={{ marginRight: "50px" }}
                    >
                      <Button
                        className="button"
                        variant="success"
                        onClick={this.AbhadetailsupdateHandler}
                        style={{
                          marginTop: "20px",
                        }}
                      >
                        Update
                      </Button>
                    </Col>
                  </Row>
                </Container>
              </Offcanvas.Body>
            </Offcanvas>
            )}
        {/*offcanvas is over */}
                  </Col> 
                  </Row>
        <br />
        <Row>
<div style={{"marginRight":"5px"}}>
  {/* searchbar,pagination,filter */}
  <input
    type="text"
    style={{ float: "left", marginBottom: "10px" }}
    onChange={this.handleFilter}
    placeholder="Search..."
  />
  <DataTable
    data={paginatedData}
    columns={this.state.tableClms}
    pagination
    paginationServer
    paginationTotalRows={
      this.state.filteredData
        ? this.state.filteredData.length
        : this.state.data.length
    }
    onChangeRowsPerPage={this.handlePerRowsChange}
    onChangePage={this.handlePageChange}
    paginationPerPage={this.state.itemsPerPage}
    keyField="id"
    className="table table-striped table-bordered dataTable no-footer employeesTableIcons"
  />
</div>
  </Row>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    );
  }
}
